<template>
	<div>
		<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
			{{ $t('integrations.use-existing-catalog-desc') }}
		</div>
	</div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
